var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartServiceimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-21.345-17.463-38.835-38.836-38.835h-216.623c-21.346 0-38.807 17.49-38.807 38.835v277.087c0 21.345 17.461 38.806 38.807 38.806h216.623C-17.463 315.893 0 298.432 0 277.087Z",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(403.133 77.035)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-57.883m-33.959 0h-43.851c-8.76 0-15.932 7.2-15.932 15.959 0 8.788 7.172 15.959 15.932 15.959H-.652",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(401.232 329.375)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h136.545c8.787 0 15.959-7.172 15.959-15.931 0-8.787-7.172-15.959-15.959-15.959H92.721m-33.989 0H.652",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(109.889 101.753)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-75.742v-111.572H109.73V0H33.988",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(239.006 504.5)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17.49c8.957 0 16.299-7.342 16.299-16.299v-15.789c0-8.986-7.342-16.328-16.299-16.328H0Z",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(163.264 472.921)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-17.49c-8.987 0-16.328-7.342-16.328-16.299v-15.789c0-8.986 7.341-16.328 16.328-16.328H0Z",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(348.736 472.921)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.119 392.927h33.732v79.994h-33.732z",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h59.244",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(226.363 472.921)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.674 7.5h216.623v30.699H147.674Z",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44.93M-7.711-32.967l21.09 90.142h18.172l21.088-90.142M75.43-10.432c0-12.387 10.121-22.535 22.535-22.535h15.252c12.387 0 22.535 10.148 22.535 22.535 0 12.416-10.148 22.536-22.535 22.536H97.965c-12.414 0-22.535 10.148-22.535 22.535 0 12.416 10.121 22.536 22.535 22.536h15.252c12.387 0 22.535-10.12 22.535-22.536M-30.5 27.014c0 16.611-13.578 30.161-30.162 30.161-16.609 0-30.188-13.55-30.188-30.161V-2.778c0-16.611 13.579-30.189 30.188-30.189 16.584 0 30.162 13.578 30.162 30.189V0h-15.023",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(233.535 203.46)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h130.139v164.325h-294.266V0h130.139",
    style: {
      strokeWidth: 14.995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(272.994 133.416)",
    fill: "none",
    stroke: "#00206d",
    strokeWidth: 14.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartServiceimg);
export default __webpack_public_path__ + "static/media/start_serviceimg.7b80b33634b42a23c42e34c16e415bf9.svg";
export { ForwardRef as ReactComponent };